import { Stack, styled } from '@mui/material';

export const MapContainer = styled(Stack)`
    position: relative;
    flex: 1;
    background-image: radial-gradient(rgba(0, 0, 0, 0.12) 1px, transparent 0);
    background-size: 10px 10px;
    background-position: -9px -9px;

    & > svg {
        flex: 1;
    }

    & > * {
        outline: none;
    }
`;
